import { Link } from '@tanstack/react-router';
import { Search } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@farmos/ui/button';
import { BrandMark } from '@/components/layout/BrandMark';
import { openPalette } from '@/lib/palette';

/** An old link or a typo: say so, and offer search and the way home. */
export function NotFound() {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-center gap-4 px-6 py-16 text-center">
      <p
        className="flex items-center gap-1 text-7xl font-semibold text-brand/30"
        aria-hidden
        dir="ltr"
      >
        4<BrandMark className="size-16" />4
      </p>
      <h1 className="text-xl font-semibold">{t('errors.not_found')}</h1>
      <p className="max-w-sm text-sm text-muted">{t('errors.not_found_body')}</p>
      <button
        type="button"
        onClick={openPalette}
        className="flex h-12 w-72 max-w-full items-center gap-2.5 rounded-full border border-line/60 bg-panel px-4 text-sm text-muted shadow-card hover:text-ink"
      >
        <Search className="size-4" aria-hidden />
        <span className="flex-1 text-start">{t('nav.search')}</span>
        <kbd dir="ltr" className="rounded-md border border-line px-1.5 text-[11px]">
          ⌘K
        </kbd>
      </button>
      <Button variant="link" asChild>
        <Link to="/">{t('errors.go_home')}</Link>
      </Button>
    </div>
  );
}
